import * as React from "react";
import Svg, { Path } from "react-native-svg";

function CMLogo(props) {
  return (
    <Svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M9.81264 8.0943C9.81264 9.13016 9.40114 10.1236 8.66868 10.8561C7.93622 11.5885 6.94279 12 5.90693 12C4.87107 12 3.87764 11.5885 3.14518 10.8561C2.41271 10.1236 2.00122 9.13016 2.00122 8.0943H4.00106C4.00106 8.59977 4.20185 9.08453 4.55927 9.44196C4.91669 9.79938 5.40146 10.0002 5.90693 10.0002C6.4124 10.0002 6.89716 9.79938 7.25458 9.44196C7.612 9.08453 7.8128 8.59977 7.8128 8.0943H9.81264Z"
        fill="#E40046"
      />
      <Path
        d="M9.81233 2.43848C9.80663 1.98877 9.67739 1.54928 9.43874 1.16807C9.2001 0.786859 8.86123 0.478602 8.4592 0.277001C8.05717 0.0753998 7.60744 -0.0117831 7.1592 0.0249839C6.71096 0.061751 6.28145 0.221053 5.91764 0.485472C5.55384 0.214586 5.12205 0.0498814 4.67026 0.00966266C4.21847 -0.0305561 3.76438 0.0552863 3.35845 0.25765C2.95252 0.460013 2.61065 0.770971 2.37083 1.15596C2.13102 1.54096 2.00265 1.98491 2 2.43848C2 2.44368 2 2.44888 2 2.45409V6.8443H3.99953V2.45348H4.0032C4.0032 2.33423 4.05057 2.21987 4.13489 2.13555C4.21921 2.05123 4.33357 2.00386 4.45281 2.00386C4.57206 2.00386 4.68642 2.05123 4.77074 2.13555C4.85505 2.21987 4.90242 2.33423 4.90242 2.45348H4.90579V2.43787C4.90548 2.44307 4.90548 2.44828 4.90579 2.45348C4.90579 2.45868 4.90579 2.46388 4.90579 2.46908V6.8443H6.90563V2.4697H6.90899C6.90899 2.35045 6.95636 2.23609 7.04068 2.15177C7.125 2.06746 7.23936 2.02009 7.3586 2.02009C7.47785 2.02009 7.59221 2.06746 7.67653 2.15177C7.76085 2.23609 7.80821 2.35045 7.80821 2.4697H7.81189V6.8443H9.81142V2.4697C9.81264 2.45929 9.81264 2.44888 9.81233 2.43848ZM6.90685 2.45409C6.90685 2.44888 6.90685 2.44368 6.90685 2.43848V2.45409Z"
        fill="#E40046"
      />
    </Svg>
  );
}

export default CMLogo;
